import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GoalAchievedSummary } from "../utils/goal/goalCompletion";

type GoalAchievedState = {
  goal: GoalAchievedSummary | null;
};

// The Goal achieved dialog lives at app level, so it survives the goal card
// that opened it leaving a filtered list.
const goalAchievedSlice = createSlice({
  name: "goalAchieved",
  initialState: { goal: null } as GoalAchievedState,
  reducers: {
    showGoalAchieved: (state, action: PayloadAction<GoalAchievedSummary>) => {
      state.goal = action.payload;
    },
    hideGoalAchieved: (state) => {
      state.goal = null;
    },
  },
});

export const { showGoalAchieved, hideGoalAchieved } = goalAchievedSlice.actions;

export default goalAchievedSlice.reducer;
